import { keyframes } from "@mui/material/styles";

export const fadeInScale = keyframes`
  0% { opacity: 0; transform: scale(0.8); }
  100% { opacity: 1; transform: scale(1); }
`;
